/* eslint-disable no-restricted-syntax */
// Use the no-important version of Aphrodite because the !important styles sometimes conflict with
// the font sizes set by FitText.
import { StyleSheet, css } from 'aphrodite/no-important';

/**
 * Wrapper for Aphrodite's StyleSheet.create() that immediately calls css() on all of the style
 * definitions to force Aphrodite to inject the styles as soon as possible.
 *
 * This is a hack to fix problems caused by trying to get an element's computed styles before the
 * styles injected by Aphrodite get applied to the element (such as the FitText component).
 */
export function createAndInjectStyleSheet(styleDefinitions) {
  const styles = StyleSheet.create(styleDefinitions);

  for (const className in styles) {
    if (styles.hasOwnProperty(className)) {
      css(styles[className]);
    }
  }

  return styles;
}
